import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 報價單列表：固定依單號降冪，後端不收 `sort`（未知 key 回 400 INVALID_SEARCH_FIELD）。
 * `status`、`customer_id` 只收單值，前端篩選維持單選。
 *
 * @param {object} listQuery
 */
export async function fetchQuotationList(listQuery) {
  const { data: raw } = await request.get('/crm/quotations', {
    params: listQueryToApiParams({ ...listQuery, sort: [] }),
  });
  return parseVer4ListResponse(raw);
}
